<template>
  <div id="pemberitahuan-integrasi">
    <div class="pemberitahuan-negatif-wrapper mb-5">
      <h6 class="m-t-0 m-b-20">
        <i class="bi bi-exclamation-circle"></i> Pengiriman Berita Negatif
        <i
          class="bi bi-question-circle text-blue"
          v-tooltip.right="{ ref: 'negatifHelper' }"
        ></i>
      </h6>
      <div ref="negatifHelper" class="tooltip-content">
        <p>
          <b>Pengiriman Berita Negatif</b>. Ketika Anda mengaktifkan
          pemberitahuan berita negatif, maka Anda akan mendapatkan pemberitahuan
          ketika ada postingan dengan konten yang bersifat negatif.
        </p>
      </div>
      <loading-component v-if="is_loading_alert" />
      <form v-else @submit.prevent="submitAlert" class="mt-4 pl-2">
        <!-- media cetak -->
        <div class="row">
          <div class="col-md-2">
            <span class="font-weight-bolder">Media Cetak :</span>
          </div>
          <div class="col-md-9">
            <div
              class="form-check switch switch-lg complete right d-flex m-b-0"
            >
              <input
                type="checkbox"
                id="media-cetak-toggle"
                v-model="negatif_params.media_cetak.status"
              />
              <label for="media-cetak-toggle"></label>
              <span class="ml-1">{{
                negatif_params.media_cetak.status ? "ON" : "OFF"
              }}</span>
            </div>
          </div>
        </div>
        <!-- tier media cetak -->
        <div v-if="negatif_params.media_cetak.status == 1" class="row mt-3">
          <div class="col-md-2">
            <span class="font-weight-bolder">Tier Media Cetak :</span>
          </div>
          <div class="col-md-5">
            <div class="d-flex">
              <div class="form-check ml-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="untier"
                  v-model="negatif_params.media_cetak.tier[0]"
                  :required="
                    negatif_params.media_cetak.status == true &&
                    !negatif_params.media_cetak.tier.includes(true)
                  "
                />
                <label class="form-check-label" for="untier"> Untier </label>
              </div>
              <div class="form-check mx-auto">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="tier-1-cetak"
                  v-model="negatif_params.media_cetak.tier[1]"
                />
                <label class="form-check-label" for="tier-1-cetak">
                  Tier 1
                </label>
              </div>
              <div class="form-check mx-auto">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="tier2-cetak"
                  v-model="negatif_params.media_cetak.tier[2]"
                />
                <label class="form-check-label" for="tier2-cetak">
                  Tier 2
                </label>
              </div>
              <div class="form-check mx-auto">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="tier3-cetak"
                  v-model="negatif_params.media_cetak.tier[3]"
                />
                <label class="form-check-label" for="tier3-cetak">
                  Tier 3
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="tier4-cetak"
                  v-model="negatif_params.media_cetak.tier[4]"
                />
                <label class="form-check-label" for="tier4-cetak">
                  Tier 4
                </label>
              </div>
            </div>
          </div>
        </div>
        <!-- online news -->
        <div class="row mt-4">
          <div class="col-md-2">
            <span class="font-weight-bolder">Online News :</span>
          </div>
          <div class="col-md-9">
            <div
              class="form-check switch switch-lg complete right d-flex m-b-0"
            >
              <input
                type="checkbox"
                id="media-online-toggle"
                v-model="negatif_params.news.status"
              />
              <label for="media-online-toggle"> </label>
              <span class="ml-1">{{
                negatif_params.news.status ? "ON" : "OFF"
              }}</span>
            </div>
          </div>
        </div>
        <!-- tier online news -->
        <div v-if="negatif_params.news.status == 1" class="row mt-3">
          <div class="col-md-2">
            <span class="font-weight-bolder">Tier Online News :</span>
          </div>
          <div class="col-md-5">
            <div class="d-flex">
              <div class="form-check ml-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="untier-news"
                  v-model="negatif_params.news.tier[0]"
                  :required="
                    negatif_params.news.status == true &&
                    !negatif_params.news.tier.includes(true)
                  "
                />
                <label class="form-check-label" for="untier-news">
                  Untier
                </label>
              </div>
              <div class="form-check mx-auto">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="tier1-online"
                  v-model="negatif_params.news.tier[1]"
                />
                <label class="form-check-label" for="tier1-online">
                  Tier 1
                </label>
              </div>
              <div class="form-check mx-auto">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="tier2-online"
                  v-model="negatif_params.news.tier[2]"
                />
                <label class="form-check-label" for="tier2-online">
                  Tier 2
                </label>
              </div>
              <div class="form-check mx-auto">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="tier3-online"
                  v-model="negatif_params.news.tier[3]"
                />
                <label class="form-check-label" for="tier3-online">
                  Tier 3
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="tier4-online"
                  v-model="negatif_params.news.tier[4]"
                />
                <label class="form-check-label" for="tier4-online">
                  Tier 4
                </label>
              </div>
            </div>
          </div>
        </div>
        <!-- cakupan online news -->
        <div v-if="negatif_params.news.status == 1" class="row mt-2">
          <div class="col-md-2">
            <span class="font-weight-bolder"
              >Cakupan Media : <span class="text-danger">*</span></span
            >
          </div>
          <div class="col-md-9">
            <div class="d-flex">
              <div class="form-check ml-2 mr-4">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="news-nasional"
                  v-model="negatif_params.news.cakupan.nasional"
                  :required="!negatif_params.news.cakupan.internasional"
                />
                <label class="form-check-label" for="news-nasional">
                  Nasional
                </label>
              </div>
              <div class="form-check mr-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="news-internasional"
                  v-model="negatif_params.news.cakupan.internasional"
                  :required="!negatif_params.news.cakupan.nasional"
                />
                <label class="form-check-label" for="news-internasional">
                  Internasional
                </label>
              </div>
            </div>
          </div>
        </div>
        <!-- id whatsapp group -->
        <!-- <div class="row mt-4">
          <div class="col-md-2 mt-2">
            <span class="font-weight-bolder">ID whatsapp Group :</span>
          </div>
          <div class="col-md-5">
            <div class="input-group input-group-right mb-3">
              <input
                type="text"
                class="form-control ml-2"
                placeholder="Masukkan ID Whatsapp Group Anda"
                :disabled="!is_edit_wa"
                style="
                  width: 98% !important;
                  height: 2.6rem !important;
                  border-top-left-radius: 4px;
                  border-bottom-left-radius: 4px;
                "
                v-model="negatif_params.wa_group_id"
              />
              <div class="input-group-append" @click="is_edit_wa = !is_edit_wa">
                <span
                  class="input-group-text text-primary btn bg-transparent hoverable"
                  style="
                    border-top-right-radius: 4px;
                    border-bottom-right-radius: 4px;
                  "
                  data-toggle="tooltip"
                  title="Edit"
                >
                  <i class="bi bi-pencil-square"></i>
                </span>
              </div>
            </div>
          </div>
        </div> -->
        <!-- id telegram group -->
        <div class="row mt-2">
          <div class="col-md-2 mt-2">
            <span class="font-weight-bolder">ID Telegram Group :</span>
          </div>
          <div class="col-md-5">
            <div class="input-group input-group-right mb-3">
              <input
                type="text"
                class="form-control ml-2"
                placeholder="Masukkan ID Telegram Group Anda"
                :disabled="!is_edit_telegram"
                style="
                  width: 98% !important;
                  height: 2.6rem !important;
                  border-top-left-radius: 4px;
                  border-bottom-left-radius: 4px;
                "
                v-model="negatif_params.telegram_group_id"
              />
              <div
                class="input-group-append"
                @click="is_edit_telegram = !is_edit_telegram"
              >
                <span
                  class="input-group-text text-primary btn bg-transparent hoverable"
                  style="
                    border-top-right-radius: 4px;
                    border-bottom-right-radius: 4px;
                  "
                  data-toggle="tooltip"
                  title="Edit"
                >
                  <i class="bi bi-pencil-square"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- topik -->
        <div class="row mt-2">
          <div class="col-md-2">
            <span class="font-weight-bolder"
              >Topik : <span class="text-danger">*</span></span
            >
          </div>
          <div class="col-md-5">
            <div class="form-group w-auto ml-2">
              <multiselect
                v-if="topic_options"
                v-model="negatif_params.topic"
                :options="topic_options"
                :multiple="true"
                group-values="topik"
                group-label="group"
                :group-select="true"
                placeholder="Pilih topik"
                track-by="id"
                label="name"
              >
                <span slot="noResult">
                  Topik tidak tersedia! Mohon masukkan topik lain.
                </span>
                <span slot="maxElements"
                  >Anda hanya dapat memilih maksimal 3 Topik!</span
                >
              </multiselect>
            </div>
          </div>
        </div>
        <!-- submit or cancel button -->
        <div class="row">
          <div class="col-md-7">
            <div class="d-flex mt-3 float-right">
              <input type="reset" value="Batal" class="btn btn-danger mr-2" />
              <input
                :type="negatif_params.topic.length > 0 ? 'submit' : 'button'"
                value="Simpan"
                :disabled="
                  negatif_params.topic.length == 0 ||
                  (negatif_params.news.cakupan.nasional == false &&
                    negatif_params.news.cakupan.internasional == false)
                "
                class="btn btn-complete"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
    <div id="tandai-kata-page">
      <h6 class="m-t-0 m-b-20">
        <i class="bi bi-pen"></i> Tandai Kata
        <i
          class="bi bi-question-circle text-blue"
          v-tooltip.right="{ ref: 'kataHelper' }"
        ></i>
        <button
          v-if="isAdmin"
          id="tambah-kata"
          class="btn btn-success btn-icon-left pull-right"
          @click="addKata"
        >
          <i class="bi bi-plus"></i> Tambah Kata
        </button>
      </h6>
      <div ref="kataHelper" class="tooltip-content">
        <p>
          <b>Tandai kata</b> pada postingan. Ketika Anda menandai sebuah kata,
          maka Anda akan mendapatkan pemberitahuan ketika ada postingan yang
          mengandung kata tersebut.
        </p>
      </div>

      <div class="table-wrapper m-b-20">
        <table
          class="table table-hover table-condensed"
          id="daftar-kata"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th>Kata</th>
              <th v-if="isAdmin" width="10%" class="text-center">Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="is_loading_kata">
              <td colspan="2" align="center">Loading...</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <modal-dynamic-component
      v-if="modal"
      :key="modal_key"
      :modal="modal"
      :data="modal.data"
      :static="true"
    />
    <v-tour
      v-if="tour_steps.length > 0"
      name="myTour"
      :steps="tour_steps"
      :options="{ highlight: true }"
    ></v-tour>
  </div>
</template>

<script>
import swal from "sweetalert";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import loading_component from "@/views/components/loader.vue";
import modal_add_kata from "@/views/components/settings/keyword/modal_add_kata.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "tab_pemberitahuan_integrasi",
  components: {
    "modal-dynamic-component": modal_dynamic,
    "loading-component": loading_component,
    Multiselect,
  },
  data() {
    return {
      tour_steps: [],
      topik_limit: 3,
      is_loading_kata: true,
      is_loading_alert: true,
      is_loading_float: false,
      is_edit_telegram: false,
      is_edit_wa: false,
      id_project:
        this.$store.getters.user.id_project != 0
          ? this.$store.getters.user.id_project
          : parseInt(atob(this.$route.query.ref)),
      modal: null,
      modal_key: 0,
      table: null,
      media_cetak_all_tier: true,
      news_all_tier: true,
      topik_s: {},
      topic_options: [],
      negatif_params: {
        media_cetak: {
          status: 0,
          tier: [true, false, false, false, false],
        },
        news: {
          status: 0,
          tier: [true, false, false, false, false],
          cakupan: {
            nasional: true,
            internasional: true,
          },
        },
        topic: [],
        telegram_group_id: "",
        wa_group_id: "",
      },
    };
  },
  methods: {
    getAlert: function (val) {
      this.is_loading_alert = val;
      let api =
        process.env.VUE_APP_API_URL + "setting/notif-group/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          let data = response.data;

          if ("media_cetak" in data) {
            if (data.media_cetak.status == 1) {
              this.negatif_params.media_cetak.status = true;
            }
            if ("tier" in data.media_cetak) {
              for (let i = 0; i <= 4; i++) {
                if (data.media_cetak.tier.includes(i)) {
                  this.negatif_params.media_cetak.tier[i] = true;
                }
              }
            }
          }

          if ("news" in data) {
            if (data.news.status == 1) {
              this.negatif_params.news.status = true;
            }
            if (data.news.cakupan.nasional == 1) {
              this.negatif_params.news.cakupan.nasional = true;
            } else {
              this.negatif_params.news.cakupan.nasional = false;
            }
            if (data.news.cakupan.internasional == 1) {
              this.negatif_params.news.cakupan.internasional = true;
            } else {
              this.negatif_params.news.cakupan.internasional = false;
            }
            if ("tier" in data.news) {
              for (let i = 0; i <= 4; i++) {
                if (data.news.tier.includes(i)) {
                  this.negatif_params.news.tier[i] = true;
                }
              }
            }
          }
          if ("topics" in data) {
            for (let i = 0; i < data.topics.length; i++) {
              this.negatif_params.topic[i] = {
                id: data.topics[i],
                name: this.topik_s.formed[data.topics[i]],
              };
            }
          }
          this.negatif_params.wa_group_id = data.wa_group_id;
          if ("telegram_group_id" in data) {
            this.negatif_params.telegram_group_id = data.telegram_group_id;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.is_loading_alert = false;
        });
    },
    submitAlert: function () {
      let api = process.env.VUE_APP_API_URL + "setting/notif-group";
      let cetak_tier = [];
      let news_tier = [];
      let topik = [];
      for (let i = 0; i <= 4; i++) {
        if (this.negatif_params.media_cetak.tier[i] == true) {
          cetak_tier.push(i);
        }
      }
      for (let i = 0; i <= 4; i++) {
        if (this.negatif_params.news.tier[i] == true) {
          news_tier.push(i);
        }
      }
      for (let i = 0; i < this.negatif_params.topic.length; i++) {
        topik[i] = this.negatif_params.topic[i].id;
      }

      let params = {
        id_project: this.id_project,
        media_cetak: {
          status: this.negatif_params.media_cetak.status == true ? 1 : 0,
          tier: cetak_tier,
        },
        news: {
          status: this.negatif_params.news.status == true ? 1 : 0,
          tier: news_tier,
          cakupan: {
            nasional: this.negatif_params.news.cakupan.nasional == true ? 1 : 0,
            internasional:
              this.negatif_params.news.cakupan.internasional == true ? 1 : 0,
          },
        },
        telegram_group_id: this.negatif_params.telegram_group_id,
        topics: topik,
        wa_group_id: this.negatif_params.wa_group_id,
      };

      this.$http
        .post(api, params)
        .then(() => {
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Pengiriman Berita Negatif berhasil diupdate.',
              position: "top",
              timeout: 5000,
              type: "success",
            })
            .show();
        })
        .catch(() => {
          this.$("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengupdate data.',
              position: "top",
              timeout: 5000,
              type: "danger",
            })
            .show();
        });
    },
    addKata: function () {
      if (!this.modal) {
        this.modal = {
          title: "Tandai Kata",
          subtitle: "Silahkan Masukan kata yang akan ditandai",
          component: modal_add_kata,
          data: [],
        };
      } else {
        this.modal_key++;
      }
    },
    getKata: function () {
      let api = process.env.VUE_APP_API_URL + "marked-words/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.data_kata = response.data;
          } else {
            this.data_kata = [];
          }
          this.generateTable("#daftar-kata", this.data_kata);
        })
        .catch((err) => {
          console.log(err);
          this.data_kata = [];
        });
    },
    deleteKata: function (id) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus kata tersebut dari daftar kata yang ditandai.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let params = {
            _id: id,
          };
          let api = process.env.VUE_APP_API_URL + "marked-words-delete";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                self.data_kata = [];
                self.getKata();
                self
                  .$("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Kata berhasil dihapus.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              }
            })
            .catch(function (error) {
              console.log(error);
              self
                .$("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus kata.',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    generateTable: function (id, data) {
      if (this.isAdmin) {
        this.table = this.$(id).DataTable({
          destroy: true,
          data: data,
          language: {
            emptyTable: "Mohon maaf, data tidak tersedia!",
          },
          columns: [{ data: "word" }, { data: "action" }],
          columnDefs: [
            {
              render: function (data, type, row) {
                let btn =
                  '<center><button id="hapus-kata" class="btn btn-danger btn-sm del" data-id="' +
                  row._id.$oid +
                  '"><i class="bi bi-trash"></i></button></center>';
                return btn;
              },
              orderable: false,
              targets: 1,
            },
          ],
        });
      } else {
        this.table = this.$(id).DataTable({
          destroy: true,
          data: data,
          language: {
            emptyTable: "Mohon maaf, data tidak tersedia!",
          },
          columns: [{ data: "word" }],
        });
      }
    },
    getTopic: function () {
      var self = this;
      let api =
        process.env.VUE_APP_API_URL + "display-topics/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            self.topik_s = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          self.getAlert(true);
          self.loadTopic();
        });
    },
    loadTopic: function () {
      let topik = [];
      let tmp;
      let group_topic = [];

      for (let row in this.topik_s.formed) {
        tmp = {
          id: row,
          name: this.topik_s.formed[row],
        };
        topik.push(tmp);
      }

      group_topic.push({
        group: "Media Konvensional",
        topik: topik,
      });
      this.topic_options = group_topic;
    },
  },
  computed: {
    isAdmin: function () {
      let user_role = this.$store.getters.user.role;
      if (user_role == 1 || user_role == 2) {
        return true;
      }
      return false;
    },
  },
  created: function () {
    this.getTopic();
    this.getKata();
  },
  mounted: function () {
    let self = this;
    self.$("#daftar-kata tbody").on("click", ".del", function () {
      var tr = self.$(this).closest("tr");
      var data = self.table.row(tr).data();
      self.deleteKata(data._id.$oid);
    });
    let v_step = [];
    v_step[0] = {
      target: "#tab-vertical",
      header: {
        title: "Tab Menu",
      },
      content: `Anda dapat memilih salah satu untuk melihat detail dari menu.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#tambah-kata",
      header: {
        title: "Tombol Tambah Kata",
      },
      content: `Klik untuk menambahkan data kata baru.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#daftar-kata_filter",
      header: {
        title: "Cari Item Tabel",
      },
      content: `Masukkan kata kunci untuk mencari kata yang diinginkan.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#daftar-kata",
      header: {
        title: "Tabel Kata",
      },
      content: `Menampilkan daftar kata tersedia.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#hapus-kata",
      header: {
        title: "Tombol Hapus Kata",
      },
      content: `Klik untuk menghapus kata yang dipilih.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };

    this.tour_steps = v_step;
  },
};
</script>
